module.exports = __webpack_public_path__ + "img/less-menu-high-contrast.0cd37ad9.svg";